import { getObjectUtil } from 'packages/src'
import { REDUX_MODEL_KEY } from '../../constants/key'
import { getValueReduxUtil } from '../get-value'

function getViewedAtReduxUtil (instance) {
  return (
    getValueReduxUtil(instance, REDUX_MODEL_KEY.VIEWED_AT) ||
    getObjectUtil(instance, REDUX_MODEL_KEY.VIEWED_AT)
  )
}

export { getViewedAtReduxUtil }
